import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
  Container,
  Row,
  Col,
} from "reactstrap"
import { ToastContainer } from "react-toastify";

import LogsList from "./logsList";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

// Utilities
import {
  createNotificationHelpers,
  loadUsageChargesData,
  transformUsageChargesToTableData,
  USAGE_CHARGE_TABLE_COLUMNS,
  MESSAGES
} from "../utils";

class UsageCharge extends Component {
  constructor(props) {
    super(props)
    this.state = {
      TotalLogs: 0,
      LogsDetails: { columns: [], rows: [] },
      loading: false
    }

    // Initialize notification helpers
    const notifications = createNotificationHelpers();
    this.notify_info = notifications.notify_info;
    this.notify_error = notifications.notify_error;
    this.notify_success = notifications.notify_success;
  }

  /**
   * Loads usage charges from API and updates state
   */
  loadUsageCharges = async () => {
    this.setState({ loading: true });

    const usageCharges = await loadUsageChargesData(this.notify_error);

    if (usageCharges) {
      const records = transformUsageChargesToTableData(usageCharges, USAGE_CHARGE_TABLE_COLUMNS);

      this.setState({
        TotalLogs: usageCharges.length,
        LogsDetails: records,
        loading: false
      });

      this.notify_success(MESSAGES.USAGE_CHARGE_LOADED_SUCCESS);
    } else {
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    this.loadUsageCharges();
  }

  /**
   * Renders the usage charge header with count
   */
  renderUsageChargeHeader = () => {
    const { TotalLogs } = this.state;
    return (
      <div className="d-flex justify-content-between">
        <p style={{ paddingLeft: "14px" }}>Last {TotalLogs} Usages Charge History</p>
      </div>
    );
  }

  render() {
    const { LogsDetails, loading } = this.state;
    const { t } = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <Helmet>
            <title>Veeper | AP - Usages Charge</title>
          </Helmet>
          <Container fluid>
            <Breadcrumbs
              title={t("Usages Charge")}
              breadcrumbItem={t("Usages Charge")}
            />
            {this.renderUsageChargeHeader()}
            <ToastContainer />
            <Row>
              <Col xl={12}>
                <LogsList loading={loading} logs={LogsDetails} />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

UsageCharge.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(UsageCharge)
